(function () {
    "use strict";

    angular.module("app").component("habilCpPersonInfoView", {
        templateUrl: "@/contact-person/request/cp-person-info.template.html",
        bindings: { info: "<", },
    });
})();